import type { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs } from '../../design-system';
import { BirthdaysTab } from './BirthdaysTab';
import styles from './BlogScreen.module.css';
import { PageTitle } from '../../shell/PageTitle';

/**
 * Kn·Blog — lo que pasa en la empresa. No viene del prototipo.
 *
 * Un módulo de empresa que se enciende y se apaga en Configuración global ›
 * Features (`knblog`), y que cuando está encendido sale **primero** en el menú
 * de todos: es lo único del portal que no es trabajo.
 *
 * Por pestañas desde el principio porque así se pidió —«Cumpleaños», «Avisos»,
 * entre otras—. Hoy hay una; la siguiente se agrega aquí. La pestaña viaja en la
 * dirección (`?seccion=`) para que un enlace mandado por chat abra la que es.
 */

const SECTIONS = [{ id: 'cumpleanos', label: 'Cumpleaños' }] as const;
type SectionId = (typeof SECTIONS)[number]['id'];

const isSection = (value: string | null): value is SectionId =>
  SECTIONS.some((section) => section.id === value);

export const BlogScreen = (): ReactNode => {
  const [params, setParams] = useSearchParams();
  const requested = params.get('seccion');
  const active: SectionId = isSection(requested) ? requested : 'cumpleanos';

  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <PageTitle className={styles.title}>
          Kn<span className={styles.titleDot}>·</span>Blog
        </PageTitle>
        <p className={styles.note}>Lo que pasa en Knotion.</p>
      </header>

      <Tabs
        options={SECTIONS}
        active={active}
        ariaLabel="Secciones de Kn·Blog"
        onChange={(id) => {
          setParams({ seccion: id }, { replace: true });
        }}
      />

      {active === 'cumpleanos' && <BirthdaysTab />}
    </div>
  );
};
